import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api/blog`;

export const blogAPI = {
  // Public endpoints
  getPosts: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/posts`, { params });
    return response.data;
  },

  getPostBySlug: async (slug) => {
    const response = await axios.get(`${API_BASE}/posts/${slug}`);
    return response.data;
  },

  getCategories: async () => {
    const response = await axios.get(`${API_BASE}/categories`);
    return response.data;
  },

  getPostsByCategory: async (categorySlug, params = {}) => {
    const response = await axios.get(`${API_BASE}/posts/category/${categorySlug}`, { params });
    return response.data;
  },

  // Protected endpoints (require API key)
  createPost: async (postData, apiKey) => {
    const response = await axios.post(`${API_BASE}/posts`, postData, {
      headers: { 'X-API-Key': apiKey }
    });
    return response.data;
  },

  updatePost: async (postId, postData, apiKey) => {
    const response = await axios.put(`${API_BASE}/posts/${postId}`, postData, {
      headers: { 'X-API-Key': apiKey }
    });
    return response.data;
  },

  deletePost: async (postId, apiKey) => {
    const response = await axios.delete(`${API_BASE}/posts/${postId}`, {
      headers: { 'X-API-Key': apiKey }
    });
    return response.data;
  },

  // Admin endpoints
  getAllPosts: async (apiKey, params = {}) => {
    const response = await axios.get(`${API_BASE}/admin/posts`, {
      headers: { 'X-API-Key': apiKey },
      params
    });
    return response.data;
  },

  createCategory: async (name, description, apiKey) => {
    const response = await axios.post(`${API_BASE}/admin/categories`, 
      { name, description },
      { headers: { 'X-API-Key': apiKey } }
    );
    return response.data;
  },

  createAPIKey: async (name, description, apiKey) => {
    const response = await axios.post(`${API_BASE}/admin/api-keys`,
      { name, description },
      { headers: { 'X-API-Key': apiKey } }
    );
    return response.data;
  }
};
